import { render, staticRenderFns } from "./TheAttainment.vue?vue&type=template&id=6187a474"
import script from "./TheAttainment.vue?vue&type=script&lang=js"
export * from "./TheAttainment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports